/*
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-07-01 22:32:43
 * @LastEditors: 雷安刚 15108293674@163.com
 * @LastEditTime: 2024-08-09 09:55:21
 * @FilePath: \商户端\front_admin\src\components\libs\apiUrl.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
if (process.env.NODE_ENV == "development") {
  //本地
  window.baseGate.ApiUrl = "http://test-merchant.joolgo.cn";
  window.baseGate.accessKeyId = "LTAI4GDadFZy3FUgV68kFgLe";
  window.baseGate.accessKeySecret = "ZXlEQKSHoOyPCl12j905Meb85SEGi9";
  window.baseGate.accountUrl = "http://localhost:8090";
  window.baseGate.bucket = "devrepos";
  window.baseGate.sjUrl = "http://test.joolgo.com/joolgoSJ.html";
}
if (process.env.NODE_ENV == "env") {
  //253
  window.baseGate.ApiUrl = "http://192.168.2.253:9998";
  window.baseGate.accessKeyId = "LTAI4GDadFZy3FUgV68kFgLe";
  window.baseGate.accessKeySecret = "ZXlEQKSHoOyPCl12j905Meb85SEGi9";
  window.baseGate.bucket = "devrepos";
  window.baseGate.sjUrl = "http://test.joolgo.com/joolgoSJ.html";
  window.baseGate.accountUrl = "http://dev-jzpt.joolgo.cn";
}
if (process.env.NODE_ENV == "testing") {
  //252
  window.baseGate.ApiUrl = "http://test-merchant.joolgo.cn";
  window.baseGate.accessKeyId = "LTAI4GJnP2MpHxgSNmNKQZFP";
  window.baseGate.accessKeySecret = "OmpmoJ7wZrfJFO1FoxiavYPhoNsIXd";
  window.baseGate.bucket = "testrepos";
  window.baseGate.sjUrl = "http://test.joolgo.com/joolgoSJ.html";
  window.baseGate.accountUrl = "http://test-jzpt.joolgo.cn";
}
if (process.env.NODE_ENV == "pre") {
  //219
  window.baseGate.ApiUrl = "http://pre-merchant.joolgo.cn";
  window.baseGate.accessKeyId = "LTAI4GJnP2MpHxgSNmNKQZFP";
  window.baseGate.accessKeySecret = "OmpmoJ7wZrfJFO1FoxiavYPhoNsIXd";
  window.baseGate.bucket = "testrepos";
  window.baseGate.sjUrl = "http://pre.joolgo.com/joolgoSJ.html";
  window.baseGate.accountUrl = "http://pre-jzpt.joolgo.cn";
}
if (process.env.NODE_ENV == "production") {
  //线上
  window.baseGate.ApiUrl = "https://admin.joolgo.com";
  window.baseGate.accessKeyId = "LTAI4G8y8WkiBWgpraGWRqyU";
  window.baseGate.accessKeySecret = "zzwr2DUQEH4RPwoC38zYjvwh5iGtcX";
  window.baseGate.bucket = "prodrepos";
  window.baseGate.sjUrl = "https://yzd.joolgo.com/joolgoSJ.html";
  window.baseGate.accountUrl = "https://jzpt.joolgo.com";
}
